import ApiService from "./ApiService"
import apiConstents from "views/eywafarm/ViewRecommendation/utils/constent"

export async function apiGetFetchPackages(query) {
    return ApiService.fetchData({
        url: `dr-package/${query?.id}/list?partnerId=${query?.partner}`,
        method: 'get',
    })
}

export async function apiGetFetchPackageHistoryList(query) {
    return ApiService.fetchData({
        url: `packages/get/json-versions?draftPackageId=${query?.draftPackageId}&packageId=${query.packageId}`,
        method: 'get',
    })
}

export async function apiGetFetchStates(query) {
    return ApiService.fetchData({
        url: `cropcycle/${query}/state`,
        method: 'get',
    })
}

export async function apiUpdatePackages(id, data){
    return ApiService.fetchData({
        url: `draft-packages/${id}`,
        method: 'put',
        data
    })
}

export async function apiRestorePackageVersion(data){
    return ApiService.fetchData({
        url: `package/retreive/previous-version`,
        method: 'post',
        data
    })
}

export async function apiPublishPacakge(data){
    return ApiService.fetchData({
        url: `package/clone-to-published`, 
        method: 'post',
        data
    })
}

export async function apiUpdatePackagesCustom(id, data){
    return ApiService.fetchData({
        url: `dr-package/${id}/edit`,
        method: 'put',
        data
    })
}

export async function apiUpdatePackagesCharacterOptionMapCustom(id, data){
    return ApiService.fetchData({
        url: `dr-package/${id}/characterOptions/edit`,
        method: 'put',
        data
    })
}


export async function apiGetFetchCharacters(query) {
    return ApiService.fetchData({
        url: `cropcycle/${query}`,
        method: 'get',

    })
}


export async function apiGetFetchAuthors(query){
    return ApiService.fetchData({
        url: `partners/${query}?populate[0]=tenePartnerUsers&populate[1]=tenePartnerUsers.tene_partner_user_info,tenePartnerUsers.tene_partner_user_info.tene_partner_roles`,
        method: 'get',
        // params
    })
}

export async function apisavePackages(data) {
    return ApiService.fetchData({
        url: `dr-package/addnew`,
        method: 'post',
        data
    })
}

export async function apiGetDateLabels() {
    return ApiService.fetchData({
        url: `/practice-start-dates`,
        method: 'get',
    })
}

//Recommendation's API's

export async function apiGetSinglePackage(packageId){
    return ApiService.fetchData({
        url: `draft-packages/${packageId}?${apiConstents?.PackagePopulate}`,
        method: 'get',
    })
}

export async function apiGetDraftPackageMapping(id){
    return ApiService.fetchData({
        url: `draft-packages/${id}?populate=fertilizer_set,package`,
        method: 'get',
    })
}

export async function apiSaveAssignVersion(data){
    return ApiService.fetchData({
        url: `/pw/draftPackage/clone-to-s3`,
        method: 'post',
        data
    })
}

// Custom Character APIs
export async function apiAddCustomCharacter(data) {
    return ApiService.fetchData({
        url: `custom-crop-profile-characters/add`,
        method: 'post',
        data
    })
}

export async function apiUpdateCustomCharacter(data) {
    return ApiService.fetchData({
        url: `custom-crop-profile-characters/add`,
        method: 'post',
        data
    })
}

export async function apiDeleteCustomCharacter(data) {
    return ApiService.fetchData({
        url: `custom-crop-profile-characters/add`,
        method: 'post',
        data
    })
}
export async function apiFetchCustomCharacters(cropCycleId, partnerId) {
  return ApiService.fetchData({
    url: `/cropcycle/${cropCycleId}/partner/${partnerId}`,
    method: 'get', 
  });
}
export async function apiFetchLanguages() {
    return ApiService.fetchData({
        url: `/languages`,
        method: 'get',
    })
}
